import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';

export const experimentalSynchronySnapshot: ExperimentalQueries['experimentalSynchronySnapshot'] = (
	_,
	{ jwt, url, entityId },
) => {
	return new Promise((resolve, reject) => {
		/* eslint-disable import/dynamic-import-chunkname */
		void import(
			/* webpackChunkName: "loadable-ts-ignoretherearecurrentlynotypesforthatpackageatlassianprosemirror-synchrony-pluginbuildcontent-reconciler" */
			// @ts-ignore there are currently no types for that package
			'@atlassian/prosemirror-synchrony-plugin/build/content-reconciler'
		).then(({ requestSnapshot }) => {
			/* eslint-enable import/dynamic-import-chunkname */
			requestSnapshot({ jwt, url, entityId }).then(
				(response: Response) => {
					if (response.ok) {
						// TODO FIXME error should be handled properly via `reject`
						// eslint-disable-next-line
						response.json().then((json) =>
							resolve({
								adf: JSON.stringify(json.state.value.adf),
								title: json.state.value.title,
							}),
						);
					} else if (response.status === 404 || response.status === 401) {
						/**
						 * When creating a new page this endpoint 404s
						 *
						 * We also return nulls for 401's as a defensive measure.
						 * Currently we use a JWT from the store which could have gone stale.
						 * Synchrony is able to refresh it itself (was pass it function), but I haven't
						 * been able to figure out how do that with apollo
						 */
						return resolve({ adf: null, title: null });
					} else {
						reject(new Error('Failed to load content snapshot from editing services'));
					}
				},
				(err: any) =>
					err
						? reject(err)
						: reject(
								new Error('Unknown error when loading content snapshot from editing services'),
							),
			);
		});
	});
};
